/**
 * Component Quickview Functionality
 *
 * Creates Dialog for componentquickview.isml
 *
 * @author Ryan Hutchinson (rhutchinson@lyonscg.com)
 */
'use strict';
var dialog = require('../../dialog');

var componentQuickview = {

	data: {
		qvBtn: null,
		element: null,
		activeClass: 'active'
	},

	init: function () {
		componentQuickview.data.qvBtn = $('.component-wrapper .quickview');
		componentQuickview.getcomponentpage();
	},

	/* *
	 * Get component quickview landing page Function
	 *
	 * @method getcomponentpage
	 * @return VOID
	 * */

	getcomponentpage: function () {
		componentQuickview.data.qvBtn.on('click', function (e) {
			e.preventDefault();
			var url = $(this).attr('href');
			// Open dialog
			dialog.open({
				url: url,
				options: {
					dialogClass: 'componentQuickview',
					open: function () {
						componentQuickview.data.element = $('.tabs-menu li');
						componentQuickview.toggleTab();

						// HCS-56 remove active state from buttons
						if (document.activeElement) {
							$(document.activeElement).blur();
						}
					}
				}
			});
		});
	},

	/* *
	 * Toggles class to element on click
	 *
	 * @method toggleTab
	 * @return VOID
	 * */

	toggleTab: function () {
		componentQuickview.data.element.on('click touchstart', function (e) {
			e.preventDefault();
			$(this).toggleClass(componentQuickview.data.activeClass);
		});
	}
};
module.exports = componentQuickview;
